import * as THREE from 'three';
import MoveObject from './MoveObject.js';
import SelectObject from './SelectObject.js';
import ObjectGenerator from './ObjectGenerator.js';

export default class SimsController{
	constructor(camera, scene, outlinePass, canvas) {
		this.camera = camera;
		this.scene = scene;
		this.outlinePass = outlinePass;
		this.canvas = canvas;
		this.simsData = {canMove: true, visible: true, added: true, id: 0, moved: false, basePos:{x: 0, y: 0, z: 0}, rotated: false, baseRot:{x: 0, y: 0, z: 0}};
		this.selectedObject = [];
		this.clickedObjectOffset = [];
		this.selectedObjectOffset = [];
		this.objectsInScene = [];
		this.moveObjectController = new MoveObject(camera);
		this.selectObjectController = new SelectObject(camera, scene, outlinePass);
		this.objectGenerator = new ObjectGenerator();
		this.movingObject = false;
		this.offsetIntersectionSet = false;
		this.objectType = [["Table_Ronde", "Table ronde"],
		["Ronde", "Table ronde avec chaises"],
		["Table_Reunion", "Table de réunion"],
		["Classe", "Table de réunion avec chaises"],
		["Pole", "Pole de travail"],
		["Table_Buffet", "Table de buffet"],
		["Table_Buffet_Petit", "Petite table de buffet"],
		["Mange_Debout", "Mange debout"],
		["Gueridon", "Gueridon"],
		["Chaise_Bleue", "Chaise bleue"],
		["Fauteuil_Orange", "Fauteuil orange"],
		["Fauteuil_Grand_Gris", "Grand fauteuil gris"],
		["Canape", "Canape"],
		["Praticable", "Praticable"],
		["Grand_Ecran", "Grand écran"],
		["Pot", "Pot"],
		["Enceintes", "Enceintes"],
		["Potelets", "Potelets"],
		["RetourEcran", "Retour ecran"],
		["Pupitre", "Pupitre"],
		["Paper_Board", "Paper board"],
		["Portant", "Portant"],
		["Chaise_Haute", "Chaise haute"],
		["Table_Basse_Bois", "Table basse"],
		["Table_Basse_Marbre", "Table basse"],
		["Stand_2_2", "Stand 2x2"],
		["Stand_2_3", "Stand 2x3"],
		["Stand_3_3", "Stand 3x3"],
		["Stand_4_4", "Stand 4x4"],
		["Prise", "Prise électrique"],
		["Sortie_Secours", "Sortie de secours"]];
		this.SetListeners();

		this.simsDataLoaded = false;
	}

	CheckRaycast(mousePos) {
		this.selectedObject = this.selectObjectController.CheckRaycast(mousePos);
	}

	SimsFunction(functionName, data) {
		if (typeof this.moveObjectController[functionName] === "function") {
			if (data) {
				this.moveObjectController[functionName](this.selectedObject, data);
			}
			else {
				this.moveObjectController[functionName](this.selectedObject);
			}
		}
		else if (typeof this.selectObjectController[functionName] === "function") {
			if (data) {
				this.selectedObject = this.selectObjectController[functionName](data);

			}
			else {
				this.selectedObject = this.selectObjectController[functionName]();
			}
		}
		else if (typeof this[functionName] === "function") {
			if (data) {
				this[functionName](data);

			}
			else {
				this[functionName]();
			}
		}
	}

	SetListeners() {
		this.raycaster = new THREE.Raycaster();
		this.mousePos = new THREE.Vector2();
		this.offsetIntersection = new THREE.Vector3();

		window.addEventListener("pointerdown", this.OnPointerDown.bind(this));

		window.addEventListener("pointermove", this.OnPointerMove.bind(this));

		window.addEventListener("pointerup", this.OnPointerUp.bind(this));

		window.addEventListener("keydown", this.OnPressKey.bind(this));
	}

	OnPointerDown(event) {
		if (event.button != 0)
			return;

		this.clickedObject = null;

		const rect = this.canvas.getBoundingClientRect(); // Récupère la position et taille du canvas
	    const x = event.clientX - rect.left; // Coordonnée X relative au canvas
	    const y = event.clientY - rect.top;  // Coordonnée Y relative au canvas

	    // Convertir en coordonnées normalisées (-1 à 1) pour Three.js
	    this.mousePos.x = (x / rect.width) * 2 - 1;
	    this.mousePos.y = -(y / rect.height) * 2 + 1;

	    this.raycaster.setFromCamera(this.mousePos, this.camera);
	    
	    const intersects = this.raycaster.intersectObject(this.scene, true);
	    
	    for (var i = 0; i < intersects.length; i++) {
			if (intersects[i] != this.scene && intersects[i].object.name != "Line" && intersects[i].object.name != "Texte") {
				this.clickedObject = this.selectObjectController.GetObjectMoveData(intersects[i].object);
				break;
			}
		}

		if (this.clickedObject && this.selectedObject.includes(this.clickedObject)) {
			this.SetObjectsInScene();
			this.GetSelectedObjectOffset();
			this.SetupObjectOffset();
			this.moveObjectController.GetBoundingSurelevation(this.scene.children);
			this.movingObject = true;
		}
	}

	OnPointerMove(event) {
		if (!this.movingObject) return;
	    const rect = this.canvas.getBoundingClientRect(); // Récupère la position et taille du canvas
	    const x = event.clientX - rect.left; // Coordonnée X relative au canvas
	    const y = event.clientY - rect.top;  // Coordonnée Y relative au canvas

	    // Convertir en coordonnées normalisées (-1 à 1) pour Three.js
	    this.mousePos.x = (x / rect.width) * 2 - 1;
	    this.mousePos.y = -(y / rect.height) * 2 + 1;

	    this.raycaster.setFromCamera(this.mousePos, this.camera);
        
        // Créer un plan pour trouver l'intersection avec la souris
        const plane = new THREE.Plane(new THREE.Vector3(0, 1, 0), 0);
        const intersection = new THREE.Vector3();
        
        if (this.raycaster.ray.intersectPlane(plane, intersection)) {
        	if (this.offsetIntersectionSet) {
        		var offsetToSend = new THREE.Vector3();
        		offsetToSend.x = intersection.x - this.offsetIntersection.x;
        		offsetToSend.z = intersection.z - this.offsetIntersection.z;
        		this.moveObjectController.MoveObjectOffsetPosition(this.clickedObject, this.clickedObjectOffset, offsetToSend);
        		
        		this.CheckSnap();
	        }
	        else {
	        	this.offsetIntersection = intersection;
	        	this.offsetIntersectionSet = true;
	        }
        }
	}

	OnPointerUp(event) {
		this.movingObject = false;
	    this.offsetIntersectionSet = false;
	}

	OnPressKey(event) {
		if (event.key === "t" || event.key === "T") {
			this.GetModifiedObjects();
	    }
	}

	SetupObjectOffset() {
		this.clickedObjectOffset = this.clickedObject.position.clone();
	}

	HideObject() {
		for(var i = 0; i < this.selectedObject.length;i++) {
			this.selectedObject[i].visible = false;
			this.selectedObject[i].simsData.visible = false;
		}
		this.selectObjectController.ResetSelection();
	}

	DupliqueSelection() {
		for (var i = 0; i < this.selectedObject.length; i++) {
			var o = this.objectGenerator.CloneElement(this.selectedObject[i], this.selectedObject[0].parent, {refObject: this.selectedObject[i]});
			o.simsData.id += 1000;
			o.simsData.added = true;
		}
	}

	AddElementFromBibliotheque(objectName) {
		var sceneCenter = this.getSceneCenter();
		var posToSend = {posX: this.scene.parent.position.x * -1, posZ: this.scene.parent.position.z * -1};
		this.objectGenerator.AddElement(objectName, this.scene, posToSend, undefined, this.simsData, true);
	}

	SetSimsData(data) {
		if (this.simsDataLoaded)
			return;
		var dataToApply = {};
		for (var i = 0; i < data.length; i++) {
			if (data[i].hasOwnProperty("a")) {
				dataToApply = {posX: data[i].px, posY: data[i].py, posZ: data[i].pz,
								rotX: data[i].rx, rotY: data[i].ry, rotZ: data[i].rz};
				this.objectGenerator.AddElement("bibliotheque/" + this.objectType[data[i].t][0], this.scene, dataToApply, undefined, this.simsData, true);
			}
			else {
				var obj = this.GetObjectById(data[i].id, data[i].t);
				
				if (data[i].hasOwnProperty("v")) {
					obj.visible = false;
					obj.simsData.visible = false;
				}
				else {
					if (data[i].hasOwnProperty("px")) {
						dataToApply = {x: data[i].px, y: data[i].py, z: data[i].pz};
						this.moveObjectController.MoveObjectToPos(obj, dataToApply);
					}
					if (data[i].hasOwnProperty("rx")) {
						dataToApply = {x: data[i].rx, y: data[i].ry, z: data[i].rz};
						this.moveObjectController.RotObjectToRot(obj, dataToApply);
					}
				}
			}
		}
		this.simsDataLoaded = true;
	}

	RefreshObjectInScene() {
		this.SetObjectsInScene();

		var countObjects = this.objectsInScene.reduce((acc, obj) => {
		    const name = obj.name;
		    acc[name] = (acc[name] || 0) + 1;
		    return acc;
		}, {});
		
		var newText = "Tous les éléments :\n"
		for (var i = 0; i < this.objectType.length; i++) {
			if (this.objectType[i][0] in countObjects) {
			    newText += `${this.objectType[i][1]} : ${countObjects[this.objectType[i][0]]}\n`;
			}
		}

		var elem = document.getElementById("all-element");
		elem.innerText = newText;

	}

	GetSimsData() {
		var dataToSend = "";
		var objectModified = this.GetModifiedObjects();

		for (var i = 0; i < objectModified.length; i++) {
			if (i != 0) {
				dataToSend += "," + this.GetObjectData(objectModified[i]);
			}
			else {
				dataToSend += this.GetObjectData(objectModified[i]);
			}
		}
		return dataToSend;
	}

	GetObjectData(obj) {
		var dataToSend = "{\"id\":" + obj.simsData.id;
		
		dataToSend += ",\"t\":" + this.objectType.findIndex(item => item[0] === obj.name);

		if (obj.simsData.visible) {
			if (obj.simsData.added) {
				dataToSend += ",\"a\":1";
				obj.simsData.moved = true;
				obj.simsData.rotated = true;
			}

			if (obj.simsData.moved) {
				dataToSend += ",\"px\":" + obj.position.x.toFixed(2) + ",\"py\":" + obj.position.y.toFixed(2) + ",\"pz\":" + obj.position.z.toFixed(2) + "";
			}
			if (obj.simsData.rotated) {
				dataToSend += ",\"rx\":" + obj.rotation.x.toFixed(2) + ",\"ry\":" + obj.rotation.y.toFixed(2) + ",\"rz\":" + obj.rotation.z.toFixed(2) + "";
			}
		}
		else {
			dataToSend += ",\"v\":0";
		}

		dataToSend += "}";

		return dataToSend;
	}

	GetObjectById(id, type) {
		for (var i = 0; i < this.scene.children.length; i++) {
			if (this.selectObjectController.IsMoveDataObject(this.scene.children[i]) ) {
				if (this.scene.children[i].name == this.objectType[type][0] && this.scene.children[i].simsData.id == id)
				return this.scene.children[i];
			}
		}
	}

	GetModifiedObjects() {
		var listObjectsModified = [];
		for(var i = 0; i < this.scene.children.length; i++) {
			if (this.selectObjectController.IsMoveDataObject(this.scene.children[i])) {
				if (this.IsModifiedObject(this.scene.children[i])) {
					listObjectsModified.push(this.scene.children[i]);
				}
			}
		}

		return listObjectsModified;
	}

	IsModifiedObject(obj) {
		if ((!obj.simsData.visible && !obj.simsData.added) || 
			obj.simsData.visible && (obj.simsData.moved || obj.simsData.rotated || obj.simsData.added)) {
			return true;
		}
		return false;
	}

	getSceneCenter() {
	    const center = new THREE.Vector3(); // Vecteur pour stocker la position centrale
	    const children = this.scene.children;

	    if (children.length === 0) return this.scene.position.clone(); // Si pas d'enfants, retourner la position du parent

	    // Calculer la moyenne des positions des enfants
	    children.forEach(child => {
	        center.add(child.position);
	    });

	    center.divideScalar(children.length); // Moyenne des positions

	    return center;
	}

	SetObjectsInScene() {
		this.objectsInScene = [];
		for(var i = 0; i < this.scene.children.length; i++) {
			if (this.scene.children[i].visible && this.selectObjectController.IsMoveDataObject(this.scene.children[i])) {
				this.objectsInScene.push(this.scene.children[i]);
			}
		}
	}

	GetSelectedObjectOffset() {
		this.selectedObjectOffset = [];
		for (var i = 0; i < this.selectedObject.length; i++) {
			var pos = {};
			pos.x =  this.selectedObject[i].position.x - this.clickedObject.position.x;
			pos.z = this.selectedObject[i].position.z - this.clickedObject.position.z;
			this.selectedObjectOffset.push(pos);
		}
	}

	CheckSnap() {
		var snapData = this.moveObjectController.CheckProximity(this.clickedObject, this.objectsInScene, this.selectedObject, 0.1);
		if (snapData.snap) {
			var posToPlace = this.clickedObject.position;
			if (snapData.snapX) {
    			posToPlace.x = snapData.position.x;
    		}
    		if (snapData.snapZ) {
    			posToPlace.z = snapData.position.z;
    		}
			this.moveObjectController.MoveObjectToPos(this.clickedObject, posToPlace);
		}

		var posData = {};
		for (var i = 0; i < this.selectedObject.length; i++) {
			if (this.selectedObject[i] != this.clickedObject) {
        		this.moveObjectController.MoveObjectOffsetPosition(this.selectedObject[i], this.clickedObject.position, this.selectedObjectOffset[i]);
			}
		}
	}
}